!function (t) {
  var e = {};

  function r(i) {
    if (e[i]) return e[i].exports;
    var n = e[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return t[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
  }

  r.m = t, r.c = e, r.d = function (t, e, i) {
    r.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: i
    });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var i = Object.create(null);
    if (r.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) {
      r.d(i, n, function (e) {
        return t[e];
      }.bind(null, n));
    }
    return i;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 1);
}([function (t, e) {
  t.exports = '<svg id="particle-tracks-perlin-noise-svg"><filter id="bg-noise" x="0%" y="0%" width="100%" height="100%"><feTurbulence id="particle-tracks-perlin-turbulence" type="fractalNoise" result="bgTurbulence" baseFrequency="0.3"></feTurbulence></filter><rect x="0" y="0" width="100%" height="100%" filter="url(#bg-noise)" fill="transparent"></rect></svg>';
}, function (t, e, r) {
  "use strict";

  r.r(e);
  var i = r(0),
      n = r.n(i);

  function a(t, e) {
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  var s = function () {
    function t(e) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.targetContainer = e, this.perlinSeed = 0, this.filterTurbulence = null;
    }

    var e, r, i;
    return e = t, (r = [{
      key: "init",
      value: function value() {
        var t = this;
        this.targetContainer.innerHTML += n.a;
        var e = document.getElementById("particle-tracks-perlin-noise-svg");
        this.svg = e, this.setupSVG(e), this.filterTurbulence = document.getElementById("particle-tracks-perlin-turbulence"), setInterval(function () {
          return t.updateNoise();
        }, 500);
      }
    }, {
      key: "resize",
      value: function value() {
        var t = this.targetContainer.getBoundingClientRect();
        this.svg.style.width = t.width, this.svg.style.height = t.height;
      }
    }, {
      key: "setupSVG",
      value: function value(t) {
        var e = this.targetContainer.getBoundingClientRect();
        t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.width = e.width, t.style.height = e.height, t.style.zIndex = 0, t.style.opacity = .75;
      }
    }, {
      key: "getPerlinSeed",
      value: function value() {
        return this.perlinSeed = (this.perlinSeed + 1) % 100, this.perlinSeed;
      }
    }, {
      key: "updateNoise",
      value: function value() {
        this.filterTurbulence.setAttribute("seed", this.getPerlinSeed());
      }
    }]) && a(e.prototype, r), i && a(e, i), t;
  }();

  function c(t, e) {
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  var o = function () {
    function t(e) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.container = e;
    }

    var e, r, i;
    return e = t, (r = [{
      key: "init",
      value: function value() {
        var t = this;
        this.setupDrawArea(), setInterval(function () {
          return t.drawParticles();
        }, 25), setInterval(function () {
          return t.fadeOut();
        }, 400);
      }
    }, {
      key: "setupDrawArea",
      value: function value() {
        this.canvas = this.prepareCanvas(this.container), this.context = this.prepareContext(this.canvas);
      }
    }, {
      key: "prepareCanvas",
      value: function value(t) {
        var e = document.createElement("canvas");
        e.id = "particle-tracks-particle-canvas", t.appendChild(e), e = document.getElementById("particle-tracks-particle-canvas");
        var r = t.getBoundingClientRect();
        return e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.width = r.width, e.height = r.height, e.style.zIndex = -1, ParticleTracks.width = r.width, ParticleTracks.height = r.width, e;
      }
    }, {
      key: "prepareContext",
      value: function value(t) {
        var e = t.getContext("2d");
        return e.fillStyle = "yellow", e.fillRect(0, 0, t.width, t.height), e;
      }
    }, {
      key: "drawParticles",
      value: function value() {
        var t = this;
        ParticleTracks.activeParticles.forEach(function (e) {
          t.draw(e), e.update();
        });
      }
    }, {
      key: "draw",
      value: function value(t) {
        if (0 != t.mass && !t.stopped()) {
          var e = this.context,
              r = 10 + .0075 * t.mass - t.z;
          e.lineWidth = r, e.lineCap = "round", e.beginPath(), e.moveTo(t.x_prev, t.y_prev), e.lineTo(t.x, t.y), e.strokeStyle = this.particleTrackGradient(t.x_prev, t.x, t.y_prev, t.y, r), e.stroke(), e.closePath();
        }
      }
    }, {
      key: "particleTrackGradient",
      value: function value(t, e, r, i, n) {
        var a = t - e,
            s = r - i,
            c = Math.sqrt(a * a + s * s),
            o = t + n / 2 * (s /= c),
            l = r - n / 2 * (a /= c),
            u = t - n / 2 * s,
            h = r + n / 2 * a,
            f = this.context.createLinearGradient(u, h, o, l);
        return f.addColorStop(0, "#ffffff00"), f.addColorStop(.3 - .05 * Math.random(), "black"), f.addColorStop(.45, "#01A1FE"), f.addColorStop(.55, "#01A1FE"), f.addColorStop(.7 + .05 * Math.random(), "black"), f.addColorStop(1, "#ffffff00"), f;
      }
    }, {
      key: "fadeOut",
      value: function value() {
        this.context.fillStyle = "rgba(255,255,0,0.15)", this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      }
    }]) && c(e.prototype, r), i && c(e, i), t;
  }();

  function l(t) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function u(t, e) {
    return !e || "object" !== l(e) && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }

  function h(t) {
    return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function f(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && y(t, e);
  }

  function y(t, e) {
    return (y = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function v(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function p(t, e) {
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  function d(t, e, r) {
    return e && p(t.prototype, e), r && p(t, r), t;
  }

  var b = function () {
    function t(e, r, i, n, a, s, c, o) {
      v(this, t), this.mass = o, this.charge = c, this.chargeToMassRatio = c / o, this.x_prev = e, this.y_prev = r, this.v_x = n, this.v_y = a, this.v_z = s, this.x = this.x_prev + this.v_x, this.y = this.y_prev + this.v_y, this.z = i;
    }

    return d(t, [{
      key: "absVelocity",
      value: function value() {
        return Math.sqrt(Math.pow(this.v_x, 2) + Math.pow(this.v_y, 2));
      }
    }, {
      key: "stopped",
      value: function value() {
        return this.absVelocity() <= 2.5;
      }
    }, {
      key: "update",
      value: function value() {
        if (null != this.decayProbability && this.decayProbability > Math.random()) this.decay();else {
          var t = this.x > 2 * ParticleTracks.width || this.x < -1 * ParticleTracks.width,
              e = this.y > 2 * ParticleTracks.height || this.y < -1 * ParticleTracks.height,
              r = Math.abs(this.z) > 3;

          if (t || e || r || this.stopped()) {
            var i = ParticleTracks.activeParticles.indexOf(this);
            ParticleTracks.activeParticles.splice(i, 1);
          } else if (this.x_prev = this.x, this.y_prev = this.y, this.x = this.x_prev + this.v_x, this.y = this.y_prev + this.v_y, this.z = this.z + this.v_z, 0 != this.mass) {
            var n = this.chargeToMassRatio * this.v_y * .1,
                a = -1 * this.chargeToMassRatio * this.v_x * .13,
                s = .5 + .001 * Math.pow(this.absVelocity(), 2),
                c = s * this.v_x / this.absVelocity(),
                o = s * this.v_y / this.absVelocity();
            this.v_x = this.v_x + n - c, this.v_y = this.v_y + a - o;
          }
        }
      }
    }]), t;
  }(),
      g = function (t) {
    function e(t, r, i, n, a, s) {
      return v(this, e), u(this, h(e).call(this, t, r, i, n, a, s, -1, .5));
    }

    return f(e, b), e;
  }(),
      P = function (t) {
    function e(t, r, i, n, a, s) {
      return v(this, e), u(this, h(e).call(this, t, r, i, n, a, s, 1, .5));
    }

    return f(e, b), e;
  }(),
      k = function (t) {
    function e(t, r, i, n, a, s) {
      var c;
      return v(this, e), (c = u(this, h(e).call(this, t, r, i, n, a, s, -1, 500))).decayProbability = .02, c;
    }

    return f(e, b), d(e, [{
      key: "decay",
      value: function value() {
        var t = new g(this.x, this.y, this.z, .5 * this.v_x, .5 * this.v_y, .5 * this.v_z);
        ParticleTracks.activeParticles.push(t), this.v_x = 0, this.v_y = 0;
      }
    }]), e;
  }(),
      _ = function (t) {
    function e(t, r, i, n, a, s) {
      var c;
      return v(this, e), (c = u(this, h(e).call(this, t, r, i, n, a, s, 0, 0))).decayProbability = .3, c;
    }

    return f(e, b), d(e, [{
      key: "decay",
      value: function value() {
        var t = new g(this.x, this.y, this.z, .5 * this.v_x, .5 * this.v_y, .5 * this.v_z),
            e = new P(this.x, this.y, this.z, .5 * this.v_x, .5 * this.v_y, .5 * this.v_z);
        ParticleTracks.activeParticles.push(t, e), this.v_x = 0, this.v_y = 0;
      }
    }]), e;
  }(),
      w = function (t) {
    function e(t, r, i, n, a, s) {
      return v(this, e), u(this, h(e).call(this, t, r, i, n, a, s, 1, 900));
    }

    return f(e, b), e;
  }(),
      T = function (t) {
    function e(t, r, i, n, a, s) {
      var c;
      return v(this, e), (c = u(this, h(e).call(this, t, r, i, n, a, s, 0, 900))).decayProbability = .05, c;
    }

    return f(e, b), d(e, [{
      key: "decay",
      value: function value() {
        var t = new g(this.x, this.y, this.z, .6 * this.v_x, .6 * this.v_y, .6 * this.v_z),
            e = new w(this.x, this.y, this.z, .7 * this.v_x, .7 * this.v_y, .6 * this.v_z);
        ParticleTracks.activeParticles.push(t, e), this.v_x = 0, this.v_y = 0;
      }
    }]), e;
  }();

  function x(t, e, r) {
    return (x = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }() ? Reflect.construct : function (t, e, r) {
      var i = [null];
      i.push.apply(i, e);
      var n = new (Function.bind.apply(t, i))();
      return r && m(n, r.prototype), n;
    }).apply(null, arguments);
  }

  function m(t, e) {
    return (m = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function S(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function C(t, e) {
    for (var r = 0; r < e.length; r++) {
      var i = e[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  function M(t) {
    return t[Math.floor(Math.random() * t.length)];
  }

  var O = function () {
    function t() {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, t), this.generateParticleTypes = [P, k, _, w, T];
    }

    var e, r, i;
    return e = t, (r = [{
      key: "init",
      value: function value() {
        var t = this;
        this.createParticle(), setInterval(function () {
          return t.createParticle();
        }, 250 + 1e3 * Math.random());
      }
    }, {
      key: "createParticle",
      value: function value() {
        var t = M(this.generateParticleTypes),
            e = 20 + 30 * Math.random(),
            r = 20 + 30 * Math.random(),
            i = ParticleTracks.width,
            n = ParticleTracks.height,
            a = i * Math.random(),
            s = n * Math.random(),
            c = 1 * Math.random(),
            o = .1 * Math.random() * -1 * c / Math.abs(c),
            l = M([[0, s, c, e, r, o], [a, 0, c, r, e, o], [i, s, c, -e, r, o], [a, n, c, -r, e, o]]);
        ParticleTracks.activeParticles.push(x(t, S(l)));
      }
    }]) && C(e.prototype, r), i && C(e, i), t;
  }();

  !function (t) {
    t.ParticleTracks || (t.ParticleTracks = {}, ParticleTracks.init = function (e) {
      var r = e.container,
          i = void 0 === r ? "" : r;
      ParticleTracks.initiated || (ParticleTracks.container = document.getElementsByClassName(i)[0], ParticleTracks.container ? (ParticleTracks.noiseLayer = new s(ParticleTracks.container), ParticleTracks.noiseLayer.init(), ParticleTracks.particleCanvas = new o(ParticleTracks.container), ParticleTracks.particleCanvas.init(), ParticleTracks.activeParticles = [], ParticleTracks.generator = new O(), ParticleTracks.generator.init(), t.onresize = function () {
        ParticleTracks.noiseLayer.resize(), ParticleTracks.particleCanvas.setupDrawArea();
      }, ParticleTracks.initiated = !0, console.log("Particle tracks visualization initiated.")) : console.log("Please provide ParticleTracks with a valid container."));
    });
  }(window);
}]);